<template>
  <div ref="barEchart" style="height: 300px"></div>
</template>

<script>
export default {
  name: "barSimple",
  mounted() {
    this.initEcharts();
  },
  methods: {
    initEcharts() {
      let chartDom = this.$refs.barEchart;
      let myChart = this.$echarts.init(chartDom);
      this.myChart = myChart;

      let option = {
        title: {
          text: "学员分段成绩统计",
          left: "center",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          name: "分",
          type: "category",
          data: ["0-60", "60-70", "70-80", "80-90", "90-100"],
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          name: "人",
          minInterval: 1,
          type: "value",
        },
        grid: {
          containLabel: true,
        },
        series: [
          {
            data: [0, 0, 0, 0, 0],
            type: "bar",
            showBackground: true,
            barWidth: "auto", // 柱图宽度
          },
        ],
      };
      myChart.setOption(option);
    },
    refreshData(xAxisData = [], data = []) {
      try {
        let option = this.myChart.getOption();
        option.xAxis[0].data = xAxisData;
        option.series[0].data = data;
        this.myChart.setOption(option);
      } catch (error) {
        console.warn(error);
      }
    },
  },
};
</script>